import { Component } from "@angular/core";
import { FpCtaComponent } from "../common/fp-cta/fp-cta.component";
import { FpProcessComponent } from "../common/fp-process/fp-process.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'app-process',
    imports: [FpProcessComponent, FpCtaComponent, TranslateModule],
    templateUrl: './process.component.html',
    styleUrl: './process.component.scss'
})
export class ProcessComponent {}